import { createStore } from 'vuex'
import CourseService from '@/services/CourseService'
import createPersistedState from 'vuex-persistedstate'
import i18n from '@/i18n'

export default createStore({
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],

  state: {
    user: null,
    userNumber: null,
    language: "",

    courses: [],
    courseChoice: "",
    courseName: "",

    tests: [],
    testChoice: null,
    testId: "",
    testName: "",


    testItems:[],
    tasksIDs:[],
    testStatus: "uncompleted",

    studentAnswers: [],
    valuations: [],
    score: "",
    studentResults:[],

    errorLogin: "",
    errorRegister: "",

    wrongInput: false,

  },

  mutations: {

    // ------------------------------------------------------------------------------Language--------------------------------------------------------------------------------//
    SET_LANGUAGE(state, language) {
      state.language = language
      localStorage.setItem("language",language)
      i18n.global.locale.value = localStorage.getItem("language")
    },

    // ------------------------------------------------------------------------ ---Courses------------------------------------------------------------------------------------ //


    SET_COURSES(state, courses) {
      state.courses = courses
    },
    SET_COURSE_NAME(state, name) {
      state.courseName = name
    },
    SET_COURSE_CHOICE(state, courseChoice) {
      state.courseChoice = courseChoice
    },


    // ----------------------------------------------------------------------------Tests-------------------------------------------------------------------------------------- //

    SET_TESTS(state, tests) {
      state.tests = tests
    },
    CHOOSE_TEST(state, testChoice) {
      state.testChoice = testChoice
    },
    RESET_TESTCHOICE(state) {
      state.testChoice = null
    },

    SET_TEST_NAME(state, testName) {
      state.testName = testName
    },
    SET_TEST_ID(state, testId) {
      state.testId = String(testId)
    },
    SET_TEST_ITEMS(state, testItems){
      state.testItems = testItems
    },
    SET_TASKS_IDS(state, tasksIDs){
      state.tasksIDs = tasksIDs
    },

    SET_VALUATIONS(state, valuations){
      state.valuations = valuations
    },

    SET_STUDENT_ANSWERS(state, studentAnswers) {
      state.studentAnswers = studentAnswers
    },

    // --------------------------------------------------------------------------------Results----------------------------------------------------------------------------------------------

    SET_STUDENT_RESULTS(state, studentResults) {
      state.studentResults = studentResults.reverse()
    },

    SET_STUDENT_SCORE(state, score) {
      state.score = String(score)
    },

    SET_TEST_STATUS(state) {
      state.testStatus = "completed"
    },

    RESET_SCORE(state) {
      state.score = null
    },
 
    // ----------------------------------------------------------------------------User---------------------------------------------------------------------------------- //

    SET_USER_DATA(state, userData) {
      state.user = userData
      localStorage.setItem("user", JSON.stringify(userData))
    },
    SET_USER_NUMBER(state, userNumber) {
      state.userNumber = userNumber
    },
    CLEAR_USER_DATA(state) {
      state.user = null
      state.errorLogin = ""
      state.errorRegister = ""
      localStorage.removeItem('user')
      state.wrongInput = false
    },

    // ----------------------------------------------------------------------------Error---------------------------------------------------------------------------------- //
    SET_ERROR_LOGIN(state, error) {
      state.errorLogin = error
    },
    SET_ERROR_REGISTER(state, error) {
      state.errorRegister = error
    },
    SET_WRONG_INPUT(state, wrongInput){
      state.wrongInput = wrongInput
    }
  },


  actions: {

    //------------------------------------------------------------------------------Courses--------------------------------------------------------------------------------- //
    async fetchCourses({ commit }) {
      await CourseService.getCourses(this.state.language)
        .then((response) => {
          commit("SET_COURSES", response.data.data)        
        }).catch((error) => {
          console.log(error);
        });
    },

    //-------------------------------------------------------------------------------Tests---------------------------------------------------------------------------------- //

    async fetchTests({ commit }, courseChoice) {
      commit("SET_COURSE_CHOICE", courseChoice)
      commit("SET_COURSE_NAME", this.state.courses[courseChoice - 1].name)

      await CourseService.getTestsByCourse(courseChoice, this.state.language)
        .then((response) => {
          commit("SET_TESTS", response.data.data)
        }).catch((error) => {
          console.log(error)
        });
    },

    //--------------------------------------------------------------------------------Test---------------------------------------------------------------------------------- //

    async fetchChosenTest({ commit }) {
      await CourseService.getTest(this.state.testChoice, this.state.language)
        .then((response) => {
          commit("SET_TEST_ITEMS", response.data.data.questions),
          commit("SET_TASKS_IDS", [
          response.data.data.questions[0].id,
          response.data.data.questions[1].id,
          response.data.data.questions[2].id,
          response.data.data.questions[3].id,
          response.data.data.questions[4].id,
          response.data.data.questions[5].id,
          response.data.data.questions[6].id,
          response.data.data.questions[7].id,
          response.data.data.questions[8].id,
          response.data.data.questions[9].id,
          ]
          )
          commit("SET_TEST_ID", response.data.data.id),
          commit("SET_TEST_NAME", response.data.data.name)
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //-------------------------------------------------------------------------------Results---------------------------------------------------------------------------------- //

    async postAnswers({commit}) {  
      await CourseService.postAnswers(this.state.testName, this.state.language, this.state.studentAnswers, this.state.tasksIDs)
      .then((response) => {
        commit("SET_STUDENT_SCORE", response.data.data.score),
        commit("SET_VALUATIONS", response.data.data.valuations)
      })
      .catch((error) => {
        console.log(error);
      });
    },

    async postResult() {
      await CourseService.postResult(this.state.score, this.state.testName, this.state.courseName, this.state.courseChoice, this.state.testId, new Date())
        .catch((error) => {
          console.log(error);
        });
    },

    async getResults({commit}) {
      await CourseService.getResults(Number(this.state.courseChoice))
      .then((response)=> {
        commit("SET_STUDENT_RESULTS", response.data.data)
      })
      .catch((error) => {
        console.log(error);
      });  
    },

    //-----------------------------------------------------------------------------User Register------------------------------------------------------------------------------ //

    async loginUser({ commit }, credentials) {
      
      await CourseService.loginUser(credentials).then(({ data }) => {

        if (data != "Wrong credentials"){
        commit("CLEAR_USER_DATA")
        commit("SET_USER_DATA", data.data)
        }
        else {
          commit("SET_WRONG_INPUT", true) 
        }
        
      })
    },

    async registerUser({ commit }, credentials) {

      await CourseService.registerUser(credentials).then(({ data }) => { 
        if (data != "User Exists"){
          commit("CLEAR_USER_DATA")
          commit("SET_USER_DATA", data.data)
          }
        else {
          commit("SET_WRONG_INPUT", true) 
          }
      })   
    },

    async logOut({ commit }) {
      await commit('CLEAR_USER_DATA')
    },

    //---------------------------------------------------------------------------------Errors--------------------------------------------------------------------------------- //

    async loginError({ commit }, error) {
      await commit('SET_ERROR_LOGIN', error)
    },

    async registerError({ commit }, error) {
      await commit('SET_ERROR_REGISTER', error)
    },

    async resetTestChoice({commit}) {
      await commit('RESET_TESTCHOICE')
    },
    async resetScore({commit}) {
      await commit('RESET_SCORE')
    }

  },
  modules: {
  },

  getters: {
    token(state) {
      return state.user
    },
    loggedIn(state) {
      return !!state.user
    }
  }
})
